import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import myLeadsState from 'Stores/myLeads';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import Button from './Button';
import Input from './newInputField';
import CheckBox from './CheckBoxNew';
import { toasterState } from './toaster';

class CreateNewListState {
  @observable showCreateList = false;

  @observable callBack;

  @observable actionMethod = 'create';

  @observable defaultValue = '';

  @observable defaultListId = '';

  @action
  setShowCreateList = val => {
    if (!val) {
      this.defaultValue = '';
      this.defaultListId = '';
    }
    this.showCreateList = val;
    if (val)
      document.getElementsByTagName('body')[0].classList.add('scrollHidden');
    else
      document.getElementsByTagName('body')[0].classList.remove('scrollHidden');
  };

  @action
  setActionMethod = val => {
    this.actionMethod = val;
  };

  @action
  setDefaultValue = val => {
    this.defaultValue = val;
  };

  @action
  setDefaultListId = val => {
    this.defaultListId = val;
  };
}
const createNewListState = new CreateNewListState();

const CreateNewList = observer(props => {
  const [inputVal, setInputVal] = React.useState('');
  const [errorToolMsg, showErrorToolMsg] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [listType, setListType] = React.useState('private');

  const isCreateList = createNewListState.actionMethod === 'create';

  const changeInputVal = value => {
    if (value !== '') showErrorToolMsg('');
    setInputVal(value);
  };

  const createNewList = async () => {
    const inputValue = inputVal.trim();
    if (!isLoading)
      if (inputValue !== '') {
        if (
          inputValue.toLowerCase() === 'plugin history' ||
          inputValue.toLowerCase() === 'all leads'
        ) {
          showErrorToolMsg('Please provide a different name');
        } else if (isCreateList) {
          setIsLoading(true);
          const isSharedList = Utils.isSharedList(listType);
          const response = await myLeadsState.createList({
            name: inputValue,
            isSharedList,
          });
          setIsLoading(false);
          if (
            response?.data?.result === 'Success' &&
            response?.data?.listId !== ''
          ) {
            createNewListState.callBack(response.data.id, inputValue, isSharedList);
            Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_LIST_CREATED, {
              listName: inputValue,
              isSharedList,
            });
          }
          createNewListState.setShowCreateList(false);
        } else if (createNewListState.defaultValue === inputValue) {
          showErrorToolMsg('List name already exist');

          setInputVal(createNewListState.defaultValue);
        } else if (createNewListState.actionMethod === 'update') {
          setIsLoading(true);
          const renameCallback = (status = 'success') => {
            let str = '';
            if (status === 'success') str = 'List name updated successfully';
            else str = 'Failed to update the list name';

            toasterState.setToastMsg(
              str,
              status === 'success'
                ? CONSTANTS.TOAST_MSG_TYPES.SUCCESS_NEW
                : CONSTANTS.TOAST_MSG_TYPES.FAILURE,
            );
            setIsLoading(false);
            createNewListState.setShowCreateList(false);
          };
          myLeadsState.renameLeadsList(
            createNewListState.defaultListId,
            inputValue,
            createNewListState.defaultValue,
            renameCallback,
          );
        } else {
          createNewListState.callBack(inputValue);
        }
      } else {
        showErrorToolMsg('Please enter a name');
        setInputVal('');
      }
  };

  const submitAction = e => {
    if (e.charCode === 13) createNewList();
  };

  const closeListPopup = () => {
    createNewListState.setShowCreateList(false);
  };

  React.useEffect(() => {
    if (createNewListState.showCreateList) {
      if (createNewListState.actionMethod === 'update')
        setInputVal(createNewListState.defaultValue);
      else setInputVal('');

      if (document.getElementById('createUpdateListbox') !== undefined)
        document.getElementById('createUpdateListbox').focus();
    }
  }, [createNewListState.showCreateList]);

  return createNewListState.showCreateList ? (
    <>
      <div className="create-newlist-popup common-popup">
        <div className="popup-wrap new-list-popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => closeListPopup()}
          >
            <CloseIcon />
          </div>
          <div className="title">
            {isCreateList ? 'Create New List' : 'Rename List'}
          </div>

          <div className="popup-content-wrap">
            <Input
              error={errorToolMsg}
              label="List Name"
              inputProps={{
                id: 'createUpdateListbox',
                type: 'text',
                placeholder: 'Enter your new list name',
                value: inputVal,
                onChange: value => changeInputVal(value),
                onKeyPress: submitAction,
                autoComplete: 'off',
              }}
            />
            {isCreateList && Utils.isSharedListEnabled() && (
              <div className="share-list-option-wrapper">
                <CheckBox
                  label="Share your list with the team"
                  isChecked={listType === 'shared'}
                  onClick={() =>
                    setListType(listType === 'private' ? 'shared' : 'private')
                  }
                />
              </div>
            )}
          </div>

          <div className="popup-action-wrap">
            <Button
              btnText={isCreateList ? 'Create' : 'Update'}
              icon={false}
              iconName=""
              type="button"
              className={`popup-action-btn positive-btn${
                isLoading ? ' loading' : ''
              }`}
              loader={isLoading}
              click={createNewList}
            />
            <div
              className="popup-action-btn cancel-btn"
              onClick={() => closeListPopup()}
            >
              Cancel
            </div>
          </div>
        </div>
      </div>
      <div className="common-popup-mask" onClick={() => closeListPopup()} />
    </>
  ) : (
    ''
  );
});

export { CreateNewList, createNewListState };
export default CreateNewList;
